// EthicCred branded logo — uses the official circular seal asset.
// Switches between the full coloured seal and a monochrome mark for dark backgrounds.

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ethictrust-build/artifacts/v01glzzo_logo%20ethiccred.png";

export default function Logo({ size = 32, withWordmark = true, theme = "light", className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="EthicCred"
        width={size}
        height={size}
        className=""
        style={{ width: size, height: size, objectFit: "contain" }}
        draggable={false}
      />
      {withWordmark && (
        <span
          className={`font-display font-bold tracking-tight ${
            theme === "dark" ? "text-white" : "text-ec-ink"
          }`}
          style={{ fontSize: Math.max(16, size * 0.6) }}
        >
          EthicCred
        </span>
      )}
    </span>
  );
}

export { LOGO_URL };
